// Klient-säkra konstanter + typer för formelblad-resolution.
// Server-koden ligger i `formelblad.ts` (importerar prisma).

export type MaId = "ma1" | "ma2" | "ma3" | "ma4" | "ma5";

// Kurser kanon-mappade till sin formelblad-fil. Gy25-naming:
// ma1, ma2 = baskurser. ma3 = ma1 forts. (MATO1). ma4 = ma2 forts. (MATO2).
// ma5 = ma fördj. (MATF1). Legacy MATE3/4/5-koder bevaras för bakåtkompat
// med ev. äldre data men har inga formelblad-länkar i UI.
export const MATE_KURS_TO_MA: Record<string, MaId> = {
  MATE1A00X: "ma1",
  MATE1B00X: "ma1",
  MATE1C00X: "ma1",
  MATE2A00X: "ma2",
  MATE2B00X: "ma2",
  MATE2C00X: "ma2",
  MATO1B00X: "ma3",
  MATO1C00X: "ma3",
  MATO2000X: "ma4",
  MATF1000X: "ma5",
  // Legacy MATE3/4/5 (om gamla rutter finns kvar)
  MATE3B00X: "ma3",
  MATE3C00X: "ma3",
  MATE4: "ma4",
  MATE5: "ma5",
};

export type ResolverResult = {
  // Server-resolved kursKod om servern ensam kan avgöra (single registered
  // course eller tydlig aktivitet utan localStorage-hänsyn). null = klienten
  // måste väga in localStorage-valet och välja högsta ts.
  kursKod: string | null;
  source: "single" | "activity" | null;
  // kursKod → max(UserLastAvsnitt.updatedAt, UserLastDelavsnitt.updatedAt)
  // som epoch-ms. Klienten merger localStorage-valet och plockar maxen.
  serverTs: Record<string, number>;
};
